export default __webpack_public_path__ + "static/media/sc22.4cb203bc.png";